import { router } from "@inertiajs/react"
import { useState } from "react"
import Layout from "../components/Layout"
import Embed from "../components/Embed"
import { extractPostText } from "../lib/postText"

function detectEmbedType(url) {
  if (!url) return null
  if (url.match(/youtube\.com|youtu\.be/)) return "youtube"
  if (url.match(/open\.spotify\.com/)) return "spotify"
  return "link"
}

export default function NewPost() {
  const [text, setText] = useState("")
  const [submitting, setSubmitting] = useState(false)

  const { body, url } = extractPostText(text)
  const preview_embed_type = detectEmbedType(url)

  function handleSubmit(e) {
    e.preventDefault()
    if (!body && !url) return
    setSubmitting(true)
    router.post("/posts", { post: { body, url } }, {
      onFinish: () => setSubmitting(false),
    })
  }

  return (
    <Layout>
      <h1 className="font-serif text-2xl text-cream mb-6">new post</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <textarea
          placeholder="what are you listening to?"
          value={text}
          onChange={e => setText(e.target.value)}
          rows={6}
          className="w-full bg-stone-900 border border-stone-700 rounded-lg px-3 py-2 text-stone-100 placeholder-stone-600 focus:outline-none focus:border-stone-500 resize-none text-sm leading-relaxed"
        />

        {url && (
          <div className="pt-2">
            <Embed url={url} embed_type={preview_embed_type} />
          </div>
        )}

        <div className="flex gap-3 items-center">
          <button
            type="submit"
            disabled={submitting || (!body && !url)}
            className="px-5 py-2 bg-stone-100 hover:bg-white text-stone-900 text-sm font-medium rounded-lg transition-colors disabled:opacity-40"
          >
            {submitting ? "posting..." : "post"}
          </button>
          <a href="/" className="text-sm text-stone-500 hover:text-stone-300 transition-colors">
            cancel
          </a>
        </div>
      </form>
    </Layout>
  )
}
